export default "/images/vendor/flag-icons/flags/1x1/sv.svg?68fa4795711823f4e487c0a74b402f7f";